import { Injectable } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { ApiService } from './api.service';
import { UtilService } from './util.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class UnifiedInboxService {
    appendClass: string;
    sidebarViewActive: any = 'list';
    sideMenuOpened: boolean = false;
    currentWindowBreakPoint: any = window.innerWidth;
    isSingleConversationOpened: boolean = false;
    isOpenSideNav: boolean = true;
    rightSidebarActive: boolean = false;
    activeParams: any = 'status';
    isLoadingChat: boolean = true;
    chatsData: any = [];
    isCreateConversationActive: boolean = false;
    appendSingleConversationClass: string;
    singleChatData: any;
    activeChatId: any;
    ccEmails: any = [];
    msgTimeActive: any = 0;
    deleteNoteId: any;
    deleteChatData: any;
    selectAllInbox: boolean = false;
    selectThisPage: boolean = false;
    activeInboxChatData: any;
    currentRoute: any;
    loadEmpty: boolean = false;
    isSingleTicketOpened: boolean = false;
    isLgSizeTicketOpen: boolean = true;
    inboxSideNavAllData: any;
    activeStatusId: any = '';
    moreChatLoded: boolean = false;
    activeList: any = 'all';
    constructor(
        public _clipboardSer: ClipboardService,
        private _api: ApiService,
        private _util: UtilService,
        private _dialog: MatDialog,
        private _router: Router,
        private _activeRoute: ActivatedRoute
    ) {
        this.updateWindowState();
        this.handleDynamicClass();
        window.addEventListener('resize', () => {
            this.currentWindowBreakPoint = window.innerWidth;
            this.updateWindowState();
        });
    }

    ngOnInit(): void {
        this.handleDynamicClass();
    }

    handleDynamicClass() {
        console.log({
            sideMenuOpened: this.sideMenuOpened,
            currentWindowBreakPoint: this.currentWindowBreakPoint,
            isOpenSideNav: this.isOpenSideNav,
            isSingleConversationOpened: this.isSingleConversationOpened,
        });
        if (this.sidebarViewActive === 'table') {
            this.appendClass =
                'min-w-full max-w-full w-full bg-white lgx:min-w-full lgx:max-w-full';
        } else if (
            this.sideMenuOpened &&
            (this.currentWindowBreakPoint > 768 ||
                !this.isSingleConversationOpened)
        ) {
            this.appendClass =
                'smx:min-w-[350px] smx:max-w-[350px] lgx:min-w-[410px] lgx:max-w-[410px] xlg:min-w-[570px] xlg:max-w-[570px] min-w-full w-full max-w-full';
        }
        else if (
            !this.sideMenuOpened &&
            (this.currentWindowBreakPoint > 768! ||
                !this.isSingleConversationOpened)
        ) {
            this.appendClass =
                'smx:min-w-[350px] smx:max-w-[350px] lgx:min-w-[350px] lgx:max-w-[350px] min-w-full max-w-full w-full';
        } else if (this.isSingleConversationOpened) {
            this.appendClass =
                'smx:min-w-[350px] smx:max-w-[350px] lgx:min-w-[350px] lgx:max-w-[350px] w-0 max-smx:overflow-hidden';
        }
        else {
            this.appendClass = null;
        }

        if (this.sideMenuOpened) {
            if (this.sidebarViewActive == 'list') {
                this.appendSingleConversationClass =
                    'xlg:min-w-[calc(100%-570px)] xlg:max-w-[calc(100%-570px)] lgx:min-w-[calc(100%-410px)] lgx:max-w-[calc(100%-410px)] smx:min-w-[calc(100%-350px)] smx:max-w-[calc(100%-350px)]';
            } else {
                this.appendSingleConversationClass =
                    'xlg:min-w-[80vw] xlg:max-w-[80vw] lgx:min-w-[70vw] lgx:max-w-[70vw]';
            }
        } else {
            if (this.sidebarViewActive == 'list') {
                this.appendSingleConversationClass =
                    'smx:min-w-[calc(100%-350px)] smx:max-w-[calc(100%-350px)]';
            } else {
                this.appendSingleConversationClass =
                    'xlg:min-w-[70vw] xlg:max-w-[70vw] lgx:min-w-[80vw] lgx:max-w-[80vw] smx:max-w-[80vw] smx:min-w-[80vw]';
            }
        }

        console.log({
            appendSingleConversationClass: this.appendSingleConversationClass,
            appendClass: this.appendClass,
        });
    }

    handleSidebarToggle(dir: string) {
        if (dir == 'left') {
            this.sideMenuOpened = !this.sideMenuOpened;
            localStorage.setItem(
                'isLeftSidebarOpen',
                this.sideMenuOpened ? '1' : '0'
            );
        } else if (dir == 'right') {
            this.rightSidebarActive = !this.rightSidebarActive;
            localStorage.setItem(
                'isRightSidebarOpen',
                this.rightSidebarActive ? '1' : '0'
            );
        }
    }

    updateWindowState() {
        if (this.currentWindowBreakPoint < 1200) {
            this.sideMenuOpened = false;
            this.rightSidebarActive = false;
        } else {
            this.checkSidebarStatus();
        }
        console.log({
            sidebarViewActive: this.sidebarViewActive,
            currentWindowBreakPoint: this.currentWindowBreakPoint,
        });
        if (
            this.currentWindowBreakPoint > 768 &&
            this.sidebarViewActive == 'list' &&
            window.location.pathname.includes('unified-inbox')
        ) {
            if (this.chatsData && this.chatsData.length > 0) {
                if (this.singleChatData.inbox) {
                    this._router.navigate(['/unified-inbox'], {
                        relativeTo: this._activeRoute,
                        queryParams: {
                            type: this.activeList,
                            id: this._api.encryptId(
                                this.singleChatData.inbox.id
                            ),
                        },
                        queryParamsHandling: 'merge',
                        skipLocationChange: false,
                    });
                } else {
                    this._router.navigate(['/unified-inbox'], {
                        queryParams: {type:this.activeList, id: null },
                        queryParamsHandling: 'merge', // remove to replace the parameters entirely
                    });
                }
            }
        }
        this.handleDynamicClass();
    }

    checkSidebarStatus() {
        if (localStorage.getItem('isLeftSidebarOpen')) {
            this.sideMenuOpened =
                localStorage.getItem('isLeftSidebarOpen') == '0' ? false : true;
            this.handleDynamicClass();
        } else {
            if (this.currentWindowBreakPoint > 1200) {
                this.sideMenuOpened = true;
                this.handleDynamicClass();
            }
            localStorage.setItem(
                'isLeftSidebarOpen',
                this.sideMenuOpened ? '1' : '0'
            );
        }

        if (localStorage.getItem('isRightSidebarOpen')) {
            this.rightSidebarActive =
                localStorage.getItem('isRightSidebarOpen') == '0'
                    ? false
                    : true;
            this.handleDynamicClass();
        } else {
            if (this.currentWindowBreakPoint > 1200) {
                this.rightSidebarActive = true;
                this.handleDynamicClass();
            }
            localStorage.setItem(
                'isRightSidebarOpen',
                this.rightSidebarActive ? '1' : '0'
            );
        }
    }

    doDeleteNote(event) {
        if (event == 'yes') {
            this._api.getData(`delete-note/${this.deleteNoteId}`).subscribe({
                next: (res: any) => {
                    if (res.success) {
                        this._util.showToast(res.message);
                        this.singleChatData.notes.forEach((note, ind) => {
                            if (note.id == this.deleteNoteId) {
                                this.singleChatData.notes.splice(ind, 1);
                            }
                        });

                        this.singleChatData.inbox.msgs.forEach((msg, ind) => {
                            if (msg.note && msg.id == this.deleteNoteId) {
                                this.singleChatData.inbox.msgs.splice(ind, 1);
                            }
                        });
                    } else {
                        this._util.showToast(res.message, true);
                    }
                    this.deleteNoteId = '';
                    this._dialog.closeAll();
                },
                error: (err) => {
                    console.log('err', err);
                },
                complete() {},
            });
        } else {
            this._dialog.closeAll();
        }
    }

    // Single chat delete confirmation dialog respons process
    closeDeleteChatModal(event) {
        if (event == 'yes') {
            const fd = new FormData();
            this._api
                .getData(`delete-inbox/${this.deleteChatData.id}`)
                .subscribe({
                    next: (res: any) => {
                        if (res.success) {
                            this.selectAllInbox = false;
                            this.selectThisPage = false;
                            this._util.showToast(res.message);
                            this.chatsData.forEach((element, ind) => {
                                if (element.id == this.deleteChatData.id) {
                                    this.chatsData.splice(ind, 1);
                                    if (this.chatsData.length > 0) {
                                        this.activeInboxChatData =
                                            this.chatsData[0];
                                        this.changeActiveChat(
                                            this.chatsData[0]
                                        );
                                    } else {
                                        this.loadEmpty = true;
                                    }
                                }
                            });
                            this._dialog.closeAll();
                        } else {
                            this._util.showToast(res.message, true);
                        }
                    },
                    error: (err) => {
                        this._dialog.closeAll();
                        console.log('err', err);
                    },
                });
        } else {
            this._dialog.closeAll();
        }
    }

    // Change Active chat
    changeActiveChat(data?, e?) {
        this.isSingleConversationOpened = false;
        if (data && data.id == this.activeChatId) {
            console.log('here in false');
            this._router.navigate(['/unified-inbox'], {
                relativeTo: this._activeRoute,
                queryParams: {
                    type: this.activeList,
                    id: this._api.encryptId(data.id),
                },
                queryParamsHandling: 'merge',
                skipLocationChange: false,
            });
            return false;
        } else {
            console.log(
                'isSingleConversationOpened',
                this.isSingleConversationOpened
            );
            if (e) {
                console.log('here in e');
                e.stopPropagation();
            }
            console.log('change route');
            if (this.chatsData?.length > 0) {
                this.chatsData.forEach((chat) => {
                    if (chat.id == data.id) {
                        if (chat.badge) {
                            if (this._api.settingsData.inbox_badge) {
                                this._api.settingsData.inbox_badge -=
                                    chat.badge;
                                console.log(
                                    'inbox_badge',
                                    this._api.settingsData.inbox_badge
                                );
                                chat.badge = 0;
                            }
                        }
                    }
                });
            }
            this.activeInboxChatData = data;
            console.log('singleChatData', this.activeInboxChatData);
            this.activeChatId = data.id;
            this._api.activeTicketId = data.id;
            this._router.navigate(['/unified-inbox'], {
                relativeTo: this._activeRoute,
                queryParams: {
                    type: this.activeList,
                    id: this._api.encryptId(data.id),
                },
                queryParamsHandling: 'merge',
                skipLocationChange: false,
            });
        }
    }

    manageInboxStatus() {
        const statusMapping = {};
        if (this.inboxSideNavAllData) {
            this.inboxSideNavAllData.status.forEach((status) => {
                statusMapping[status.id] = {
                    name: status.name,
                    color: status.color
                };
            });
            console.log('statusMapping', statusMapping);

            if (this.chatsData) {
                this.chatsData.forEach((chat) => {
                    if (chat.status_id in statusMapping) {
                        chat.status_name = statusMapping[chat.status_id].name;
                        chat.color = statusMapping[chat.status_id].color;
                    }
                });
            }
        }
    }
}
